import React from 'react';
import { Row } from 'antd';

import OnTraccrTextInput from '../../../common/inputs/OnTraccrTextInput';

import TitleRow from './TitleRow';

import FieldTriggerCheckbox from './FieldTriggerCheckbox';
import FieldTriggerFlag from './FieldTriggerFlag';
import ConditionalRenderingRow from './ConditionalRenderingRow';
import DisplayText from '../../../common/text/DisplayText';
import OnTraccrCheckbox from '../../../common/inputs/OnTraccrCheckbox';
import FieldWidthSelector from './FieldWidthSelector';

import colors from '../../../constants/Colors';

const preview = ({
  configProps = {},
  id,
  responding = false,
  responses = {},
  setResponses,
  sections,
  projectId,
  templateId,
  divisions,
  isDisplay,
  onFieldTrigger,
} = {}) => {
  const {
    title = 'Title goes here',
    fieldTrigger,
    isHyperlink,
  } = configProps;

  if (responding) {
    if (responses[id]?.value !== title) {
      setResponses((oldResponses) => ({
        ...oldResponses,
        [id]: {
          value: title,
        },
      }));
    }
  }

  const formattedTitle = isHyperlink
    ? (<a href={title} target="_blank" rel="noopener noreferrer">{title}</a>)
    : title;

  return (
    <TitleRow
      title={formattedTitle}
      titleStyle={{
        fontFamily: 'open-sans',
        fontSize: 14,
        lineHeight: '18px',
        color: colors.REDESIGN_PRIMARY_TEXT,
      }}
      optional
      filter={
        fieldTrigger && !isDisplay
          ? (
            <FieldTriggerFlag
              sections={sections}
              templateId={templateId}
              projectId={projectId}
              divisions={divisions}
              configProps={configProps}
              responding={responding}
              onFieldTrigger={onFieldTrigger}
            />
          ) : null
      }
    />
  );
};

const configure = ({
  setConfigProps,
  configProps = {},
  setCanSubmit,
  sections = [],
  isExternalForm,
  templateId,
  divisions,
  projectId,
  name,
  isBoardCards,
  setFieldTriggerEditable,
  id,
  customers = [],
  projects = [],
  users = [],
  costcodes = [],
  phases = [],
  projectIdMap = {},
  vendors = [],
  equipment = [],
  formTemplates = [],
  labels = [],
  contactAddressBooks = {},
  buckets = [],
  scheduleCategories = [],
}) => {
  const {
    hasConditionalRendering = false,
    conditionalRenderingFormula,
    isHyperlink,
  } = configProps;

  const setTitle = (e) => {
    const {
      target: {
        value,
      } = {},
    } = e;
    setConfigProps({
      ...configProps,
      title: value,
    });
    setCanSubmit(value);
  };

  const setFieldTrigger = (checked) => {
    setConfigProps({
      ...configProps,
      fieldTrigger: checked,
    });
  };

  const setHasConditionalRendering = (checked) => {
    setConfigProps({
      ...configProps,
      hasConditionalRendering: checked,
    });
  };

  const setConditionalRenderingFormula = (formula) => {
    setConfigProps({
      ...configProps,
      conditionalRenderingFormula: formula,
    });
  };

  const updateCheckbox = (key) => (checked) => {
    setConfigProps({
      ...configProps,
      [key]: checked,
    });
  };

  const setWidth = (value) => {
    setConfigProps({
      ...configProps,
      width: value,
    });
  };

  const errorText = (isHyperlink && !configProps?.title?.match(/^(?:.{0,5}:)?\/\//))
    ? 'Must be a valid external link (beginning with http:// , https:// , etc)'
    : undefined;

  return (
    <div>
      <Row className="form-required-field">
        Text:
      </Row>
      <Row style={{ marginTop: 5, marginBottom: 5 }}>
        <OnTraccrTextInput
          textarea
          placeholder="Insert title here"
          onChange={setTitle}
          value={configProps.title}
        />
      </Row>
      <Row>
        <DisplayText
          style={{
            color: 'red',
            height: errorText ? 'auto' : 0,
            opacity: errorText ? 1 : 0,
          }}
          title={errorText}
        />
      </Row>
      <ConditionalRenderingRow
        onChange={setHasConditionalRendering}
        hasConditionalRendering={hasConditionalRendering}
        conditionalRenderingFormula={conditionalRenderingFormula}
        onFormulaChange={setConditionalRenderingFormula}
        sections={sections}
        id={id}
        customers={customers}
        projects={projects}
        projectIdMap={projectIdMap}
        users={users}
        costcodes={costcodes}
        phases={phases}
        vendors={vendors}
        equipment={equipment}
        formTemplates={formTemplates}
        labels={labels}
        contactAddressBooks={contactAddressBooks}
        buckets={buckets}
        scheduleCategories={scheduleCategories}
      />
      <OnTraccrCheckbox
        style={{ marginTop: 10 }}
        label="Is Hyperlink"
        value={isHyperlink}
        onChange={updateCheckbox('isHyperlink')}
        hoverNode="Text will be rendered as a clickable link in the form and PDF"
      />
      <FieldWidthSelector
        value={configProps.width}
        onChange={setWidth}
      />
      {!isBoardCards && !isExternalForm && (
        <FieldTriggerCheckbox
          onChange={setFieldTrigger}
          onEditableChange={setFieldTriggerEditable}
          sections={sections}
          projectId={projectId}
          templateId={templateId}
          divisions={divisions}
          configProps={configProps}
          setConfigProps={setConfigProps}
          name={name}
        />
      )}
    </div>
  );
};
export default {
  configure,
  preview,
  title: 'Static Text',
  description: 'Define some text to display to users filling out the form.',
};
